import axios from "@/axios-instance";

export const config = {
  frame: [
    {
      key: "studio",
      name: 'Fond photo',
      image: '/images/ia/frame/studio.png',
      prompt: 'Professional food photography on %color% background with studio lighting'
    },
    {
      key: "wood-brick",
      name: 'Sur la table',
      image: '/images/ia/frame/table.png',
      prompt: 'Professional food photography, Food plated on table, %tabletop%, with natural lighting'
    },
    {
      key: "color",
      name: 'Fond uni',
      image: '/images/ia/frame/color.png',
      prompt: 'Clean minimalist %color% solid background'
    }
  ],
  angles: [
    {
      key: "top",
      name: 'Vue du dessus',
      image: '/images/ia/angle/top.png',
      prompt: 'Top-down view directly from above'
    },
    {
      key: "upper-front",
      name: 'Plongée',
      image: '/images/ia/angle/upper-top.png',
      prompt: 'High angle shot from above at 45 degrees'
    },
    {
      key: "front",
      name: 'Vue de face',
      image: '/images/ia/angle/front.png',
      prompt: 'Straight front view at eye level'
    },
    {
      key: "hand",
      name: 'En main',
      image: '/images/ia/angle/hand.png',
      prompt: 'Food held in hand with natural gesture'
    }
  ],
  styles: [
    {
      key: "realist",
      name: 'Réaliste',
      image: '/images/ia/styles/realistic.png',
      prompt: 'Photorealistic style with natural lighting and textures, Some imperfections and irregularities to add realism, food photography style, high detail, intense contrast, 8k, ultra-realistic, natural colors, depth of field'
    },
    {
      key: "retro",
      name: 'retro',
      image: '/images/ia/styles/retro.png',
      prompt: 'Vintage retro aesthetic with warm tones and classic styling, old photography style'
    },
    {
      key: "3d-perfect",
      name: 'Parfait',
      image: '/images/ia/styles/perfect-ia.png',
      prompt: 'Perfect 3D rendered style with flawless presentation'
    },
    {
      key: "badass",
      name: 'Badass',
      image: '/images/ia/styles/badass.png',
      prompt: 'flames and smoke in the background, epic, A few sparks, Dramatic lighting, shallow depth of field, food photography style, cinematic look, high detail, intense contrast.'
    },
    {
      key: "illustration",
      name: 'Illustration',
      image: '/images/ia/styles/illustration.png',
      prompt: 'flat, Artistic illustration style with stylized elements'
    },
    {
      key: "painting",
      name: 'Peinture',
      image: '/images/ia/styles/painting.png',
      prompt: 'Hand-painted artistic style with brush strokes and artistic interpretation'
    }
  ],
  tableTexture: [
    {
      key: "darkwood",
      name: 'Bois sombre',
      image: '/images/ia/table/darkwood.png',
      prompt: 'dark wood grain tabletop, flat surface, natural rich brown tones, in front of a rustic brick wall'
    },
    {
      key: "lightwood",
      name: 'Bois clair',
      image: '/images/ia/table/lightwood.png',
      prompt: 'dark wood grain tabletop, flat surface, natural rich brown tones'
    },
    {
      key: "marble",
      name: 'Marbre',
      image: '/images/ia/table/marble.png',
      prompt: 'white marble tabletop with soft grey veining, polished surface, luxurious and realistic, natural stone detail'
    },
    {
      key: "polished-marble",
      name: 'Pierre polie',
      image: '/images/ia/table/polished-marble.png',
      prompt: 'polished black stone tabletop, deep black tones with subtle natural veining, smooth and reflective surface'
    },
    {
      key: "concrete",
      name: 'Béton',
      image: '/images/ia/table/concrete.png',
      prompt: 'polished concrete tabletop, smooth light grey surface with subtle aggregate exposure, elegant and reflective surface'
    },
  ],
  colors: [
    {
      key: "black",
      name: 'Noir',
      code: '#000000'
    },
    {
      key: "gray",
      name: 'Gris',
      code: '#cacaca'
    },
    {
      key: "blue",
      name: 'Bleu',
      code: '#59ADF0'
    },
    {
      key: "green",
      name: 'Vert',
      code: '#64B773'
    },
    {
      key: "red",
      name: 'Rouge',
      code: '#DF6032'
    },
    {
      key: "yellow",
      name: 'Jaune',
      code: '#FFF582'
    },
    {
      key: "white",
      name: 'Blanc',
      code: '#EFEFEF'
    },
  ]
}



export async function sendImageGenerationRequest(merchantId, productIds, anglePrompt, stylePrompt, details, useExistingPhotos = false) {
  return new Promise(((resolve, reject) => {
    axios.post(`/v1/merchants/${merchantId}/menu/ai/generateImage`, {productIds, anglePrompt, stylePrompt, details, useExistingPhotos})
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        })
  }));
}

export async function checkGenerationStatus(merchantId, generationIds) {
  return new Promise(((resolve, reject) => {
    axios.post(`/v1/merchants/${merchantId}/menu/ai/checkGenerationStatus`, {generationIds})
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        })
  }));
}
